export default __webpack_public_path__ + "static/media/ipfs.8247a279.png";